import { REQUEST_PERMISSIONS, RESPONSE_PERMISSIONS, REQUEST_PERMISSIONS_FAILURE } from "../actions/permissionsAction";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  permissions: null,
  errors: null,
};

const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PERMISSIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
        permissions: null,
      });
    case RESPONSE_PERMISSIONS:
      return Object.assign({}, state, {
        dataState: states.READY,
        permissions: { classificationPermissions: action.data.classificationPermissions },
      });
    case REQUEST_PERMISSIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default permissionsReducer;
